export default function ContactCta() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-[2rem] bg-primary-600 px-6 py-12 md:px-12 md:py-16">
          <div className="pointer-events-none absolute -right-10 -top-10 h-48 w-48 rounded-full bg-accent-500/30 blur-2xl"></div>
          <div className="pointer-events-none absolute -bottom-16 -left-8 h-56 w-56 rounded-full bg-accent-400/20 blur-3xl"></div>

          <div className="relative grid gap-8 md:grid-cols-2 md:items-center">
            <div>
              <p className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs font-semibold text-background-100">
                <i className="ri-mail-send-line" aria-hidden="true"></i>
                你也可以来当瓜主
              </p>
              <h2 className="mt-4 font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
                身边有反转？
                <br />
                把「瓜」投稿给我们
              </h2>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/90 md:text-base">
                你经历或见证过什么样的神转折？整理成文字发给我们，匿名收录进反转现场。优质投稿会登上神转折头条。
              </p>
            </div>

            <div className="flex flex-col items-start gap-3 sm:flex-row sm:flex-wrap md:justify-end">
              <a
                href="mailto:tougao@chigua.example?subject=吃瓜反差投稿"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600"
              >
                <i className="ri-edit-2-line" aria-hidden="true"></i>
                发邮件投稿
              </a>
              <a
                href="#faq"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-100/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-question-line" aria-hidden="true"></i>
                先看投稿规则
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}